import React from 'react';
interface InputProps {
  type?: string;
  placeholder?: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  icon?: React.ReactNode;
  error?: string;
  required?: boolean;
  className?: string;
  name?: string;
}
export function Input({
  type = 'text',
  placeholder,
  value,
  onChange,
  icon,
  error,
  required = false,
  className = '',
  name
}: InputProps) {
  return <div className="w-full" data-id="element-357">
      <div className="relative" data-id="element-358">
        {icon && <div className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" data-id="element-359">
            {icon}
          </div>}
        <input type={type} name={name} placeholder={placeholder} value={value} onChange={onChange} required={required} className={`w-full rounded-md border border-gray-300 px-4 py-3 ${icon ? 'pl-10' : ''} focus:outline-none focus:ring-2 focus:ring-[#E63946] focus:border-transparent transition-all ${error ? 'border-red-500' : ''} ${className}`} data-id="element-360" />
      </div>
      {error && <p className="mt-1 text-sm text-red-500" data-id="element-361">{error}</p>}
    </div>;
}